function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMusic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 511.983 511.983",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    x: 405.332,
    y: 236.761,
    style: {
      fill: "#D770AD"
    },
    width: 21.312,
    height: 182.06
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EC87C0"
    },
    points: "405.331,298.774 405.331,192.098 511.983,245.432  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EC87C0"
    },
    d: "M393.221,385.553c-9.358,0-17.812,3.843-23.873,10.03c-6.078-6.188-14.516-10.03-23.891-10.03 c-18.453,0-33.42,14.968-33.42,33.436c0,38.202,57.311,71.623,57.311,71.623s57.295-33.421,57.295-71.623 C426.643,400.521,411.69,385.553,393.221,385.553z"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 93.292,
    y: 107.331,
    style: {
      fill: "#967ADC"
    },
    width: 21.327,
    height: 162.71
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#AC92EB"
    },
    d: "M81.185,236.292c-9.351,0-17.812,3.843-23.874,10.039c-6.07-6.195-14.523-10.039-23.882-10.039 C14.969,236.292,0,251.26,0,269.72c0,38.21,57.311,71.646,57.311,71.646s57.303-33.437,57.303-71.646 C114.614,251.261,99.646,236.292,81.185,236.292z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 306.612,
    y: 107.331,
    style: {
      fill: "#967ADC"
    },
    width: 21.326,
    height: 140.8
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#AC92EB"
    },
    d: "M294.522,214.965c-9.375,0-17.812,3.844-23.891,10.039c-6.062-6.195-14.522-10.039-23.874-10.039 c-18.468,0-33.429,14.969-33.429,33.429c0,38.194,57.302,71.631,57.302,71.631s57.311-33.437,57.311-71.631 C327.942,229.933,312.974,214.965,294.522,214.965z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#AC92EB"
    },
    points: "93.287,149.366 327.942,107.328 327.942,21.37 93.287,63.408  "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMusic);
export default __webpack_public_path__ + "static/media/music.f8dd06681746cdc83202e7f5a2e07b64.svg";
export { ForwardRef as ReactComponent };